import {
  CreateProjectFormFieldType,
  CreateProjectFormDataType,
} from '../types/createProjectTypes';
import {
  validateProjectName,
  validateClientId,
  validateAdditionalContactEmail,
} from './projectInfoFormValidator';

export const defaultProjectFormData: CreateProjectFormDataType = {
  projectDescription: '',
  projectName: '',
  clientId: '',
  overseeingName: '',
  emailAddresses: '',
  additionalContactInfo: '',
  serviceAgreement: '',
};

export const createProjectFormFields: {
  [key in CreateProjectFormFieldType]: {
    label?: string;
    placeholder?: string;
    placeholderWithValue?: string;
    helperMsg?: string;
    maxLength: number;
    multiline?: boolean;
    validator?: (input: string, isBlur?: boolean) => boolean;
    errorIconVisible?: boolean;
    dataTestId?: string;
  };
} = {
  serviceAgreement: {
    maxLength: 0,
  },
  projectName: {
    placeholder: 'giveProjectUniqueName',
    label: 'uniqueProjectName',
    placeholderWithValue: 'uniqueProjectName',
    helperMsg: 'projectNameGuideText',
    maxLength: 50,
    validator: validateProjectName,
    errorIconVisible: true,
    dataTestId: 'uniqueProjectNameInput',
  },
  projectDescription: {
    label: 'projectDescription',
    helperMsg: 'maxCharacterCount',
    maxLength: 500,
    multiline: true,
    dataTestId: 'projectDescriptionInput',
  },
  clientId: {
    label: 'clinetPreferredID',
    placeholder: 'addClientId',
    placeholderWithValue: 'clinetPreferredID',
    helperMsg: 'addClientIdGuideText',
    maxLength: 30,
    errorIconVisible: true,
    multiline: false,
    validator: validateClientId,
    dataTestId: 'clientIdInput',
  },
  overseeingName: {
    label: 'overseeingNames',
    helperMsg: 'maxCharacterCount',
    maxLength: 500,
    multiline: true,
    dataTestId: 'overseeingNameInput',
  },
  emailAddresses: {
    label: 'emailAddresses',
    helperMsg: 'emailAddressesGuideText',
    maxLength: 500,
    multiline: true,
    validator: validateAdditionalContactEmail,
    dataTestId: 'emailAddressedInput',
  },
  additionalContactInfo: {
    label: 'additionalContactInfo',
    helperMsg: 'maxCharacterCount',
    maxLength: 500,
    multiline: true,
    dataTestId: 'additionalContactInfoInput',
  },
};
